import env from './env';

export type AppStages = 'development' | 'staging' | 'production';

interface AppConfig {
  stage: AppStages;
  sentry: {isEnable: boolean; dsn: string};
  api: {
    host: string;
    url: string;
    timeout: number;
  };
  googleClientId: string;
  pusher: {
    appKey: string;
    wsHost?: string;
    wsPort?: number;
    wssHost?: string;
    wssPort?: number;
    forceTLS?: boolean;
    encrypted?: boolean;
    disableStats?: boolean;
    enabledTransports: string[];
    authEndpoint: string;
  };

  googleMapKey: string;
  metabaseUrl: string;
  metabaseKey: string;
  googleAnalytics: {
    isEnable: boolean;
    measurementId: string;
    elevateMeasurementId: string;
  };
  gtmId?: string;

  [key: string]: any;
}

const {STAGE} = env as {STAGE: AppStages};
const config: AppConfig = {
  stage: STAGE,
  sentry: {isEnable: env.SENTRY_ENABLED, dsn: env.SENTRY_DSN},
  api: {
    host: env.API.HOST,
    url: `${env.API.HOST}/api/v1/`,
    timeout: env.API.TIMEOUT,
  },
  googleClientId: env.GOOGLE_CLIENT_ID,
  pusher: {
    appKey: env.PUSHER.APP_KEY,
    wsHost: env.PUSHER.WS_HOST,
    wsPort: env.PUSHER.WS_PORT,
    wssHost: env.PUSHER.WSS_HOST,
    wssPort: env.PUSHER.WSS_PORT,
    forceTLS: env.PUSHER.FORCE_TLS,
    encrypted: env.PUSHER.ENCRYPTED,
    disableStats: env.PUSHER.DISABLE_STATS,
    enabledTransports: env.PUSHER.ENABLED_TRANSPORTS,
    authEndpoint: env.PUSHER.AUTH_ENDPOINT,
  },
  googleMapKey: env.GOOGLE_MAP_API_KEY,
  metabaseUrl: env.METABASE_SITE_URL,
  metabaseKey: env.METABASE_KEY,
  googleAnalytics: {
    isEnable: env.GOOGLE_ANALYTICS_ENABLED,
    measurementId: env.GOOGLE_ANALYTICS_MEASUREMENT_ID,
    elevateMeasurementId: env.GOOGLE_ANALYTICS_ELEVATE_MEASUREMENT_ID,
  },
  gtmId: env.GTM_ID,
};

if (STAGE === 'staging') {
}
if (STAGE === 'production') {
}

export default config;
